export default __webpack_public_path__ + "static/media/letsencrypt.e9b9e3ab.svg";